import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import './styles.scss';

export type ToastType = 'success' | 'danger' | 'warning' | 'info';

interface ToastNotificationProps {
    show: boolean;
    onClose: () => void;
    message: string;
    type: ToastType;
    autoHide?: boolean;
    delay?: number;
}

const ToastNotification: React.FC<ToastNotificationProps> = ({
    show,
    onClose,
    message,
    type,
    autoHide = true,
    delay = 5000
}) => {
    const getIcon = () => {
        switch (type) {
            case 'success':
                return '✅';
            case 'danger':
                return '❌';
            case 'warning':
                return '⚠️';
            case 'info':
                return 'ℹ️';
            default:
                return 'ℹ️';
        }
    };

    const getTitle = () => {
        switch (type) {
            case 'success':
                return 'Sucesso';
            case 'danger':
                return 'Erro';
            case 'warning':
                return 'Atenção';
            case 'info':
                return 'Informação';
            default:
                return 'Notificação';
        }
    };

    return (
        <ToastContainer position="top-end" className="p-3 toast-notification-container">
            <Toast
                show={show}
                onClose={onClose}
                autohide={autoHide}
                delay={delay}
                bg={type}
                className="toast-notification"
            >
                <Toast.Header closeButton>
                    <strong className="me-auto">
                        <span className="icon">{getIcon()}</span>
                        {getTitle()}
                    </strong>
                </Toast.Header>
                <Toast.Body>
                    {message}
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default ToastNotification;
